import {allowedCharactersMap, StringLatinGroup} from './allowed-characters';
import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import Graphemer from "graphemer";

const splitter = new Graphemer();

/**
 * Gibt einen ValidatorFn zurück, der Latein‑Grapheme prüft.
 * @param allowNewline true, um Newlines/Tabs zu erlauben
 */
export function stringLatinValidator(allowNewline = false): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const wert = control.value;
        if (typeof wert !== 'string') {
            return { stringLatin: { error: 'notString' } };
        }

        const normalized = wert.normalize('NFC');
        const chars = splitter.splitGraphemes(normalized);


        const allowedChars = allowedCharactersMap.get(StringLatinGroup.ERLAUBTEZEICHEN);
        const allowedWhitespace = allowedCharactersMap.get(StringLatinGroup.ERLAUBTE_LEERZEICHEN);


        const invalid: string[] = [];
        for (const ch of chars) {
            if (allowedChars.has(ch)) continue;
            if (allowNewline && allowedWhitespace.has(ch)) continue;
            invalid.push(ch);
        }

        return invalid.length
            ? { "stringLatin": { invalidCharacters: Array.from(new Set(invalid)) } }
            : null;
    };
}
